import { TDataSource } from "./dataSource";
import { TEnumerationType } from "./type";

export type TStreamingPlatform = 'twitch' | 'youtube' | 'facebook' | 'facebookGaming';

export interface ISegmentProp {
  // 自身的key
  key: string;
  // 显示的文本
  label: string;
  // 转换中英文使用到的key
  labelKey?: string;
  // 传递至后端的值
  value: string;
  source?: TDataSource;
  enumType: TEnumerationType;
};

export type IStreamingPlatform = Record<TStreamingPlatform, ISegmentProp>

export const STREAMING_PLATFORM: IStreamingPlatform = {
  twitch: {
    label: 'Twitch',
    labelKey: 'dbi_streaming_twitch',
    value: 'twitch',
    key: 'twitch',
    enumType: 'platformStreaming',
  },
  youtube: {
    label: 'Youtube',
    labelKey: 'dbi_streaming_youtube',
    value: 'ytg',
    key: 'youtube',
    enumType: 'platformStreaming',
  },
  facebook: {
    label: 'Facebook',
    labelKey: 'dbi_benchmark_facebook',
    value: 'facebook',
    key: 'facebook',
    enumType: 'platformStreaming',
  },
  facebookGaming: {
    label: 'Facebook Gaming',
    labelKey: 'dbi_streaming_facebook_gaming',
    value: 'facebook',
    key: 'facebookGaming',
    enumType: 'platformStreaming',
  },
};
